import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { useCourses } from '../contexts/CourseContext';

const GroupApplication: React.FC = () => {
  const navigate = useNavigate();
  const { courses, loading } = useCourses();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 단체체험 카테고리 프로그램만 필터
  const groupPrograms = courses.filter(
    c => c.category?.includes('group') && c.is_published
  );

  return (
    <>
      <SEO
        title="단체체험(기관) 신청"
        description="동두천시 글로벌인재교육센터 단체체험 프로그램 예약 신청"
        keywords="동두천글로벌인재교육센터, 단체체험, 기관신청, 단체예약"
        path="/application/group"
      />
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Page Header */}
        <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1920&h=600&fit=crop&q=80"
              alt="Group Application"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">수강신청</p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">단체체험(기관) 신청</h1>
            <div className="w-16 sm:w-20 h-1 bg-white/70"></div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 py-8 sm:py-12 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* 안내 */}
            <div className="text-center mb-8 sm:mb-10">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">프로그램을 선택해주세요</h2>
              <p className="text-sm text-gray-500">체험할 프로그램을 선택하면 예약 캘린더로 이동합니다.</p>
            </div>

            {loading ? (
              <div className="text-center py-16">
                <p className="text-gray-400">로딩 중...</p>
              </div>
            ) : groupPrograms.length === 0 ? (
              <div className="text-center py-16">
                <p className="text-gray-500">현재 등록된 단체체험 프로그램이 없습니다.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {groupPrograms.map(program => (
                  <div
                    key={program.id}
                    onClick={() => navigate(`/application/group/${program.id}`)}
                    className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-lg hover:-translate-y-1 transition-all duration-200"
                  >
                    {program.courseImage && (
                      <div className="h-48 overflow-hidden">
                        <img
                          src={program.courseImage}
                          alt={program.courseName}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                    <div className="p-5 sm:p-6">
                      <span className="inline-block px-2.5 py-1 bg-blue-50 text-blue-600 rounded-full text-xs font-medium mb-3">
                        단체체험
                      </span>
                      <h3 className="text-lg font-bold text-gray-800 mb-2">{program.courseName}</h3>
                      {program.courseDescription && (
                        <p className="text-sm text-gray-500 line-clamp-2">
                          {program.courseDescription.replace(/<[^>]*>/g, '')}
                        </p>
                      )}
                      <div className="mt-4 text-sm font-semibold text-green-600 flex items-center gap-1">
                        예약하기 →
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* 안내 문구 */}
            <div className="mt-8 bg-amber-50 border border-amber-200 rounded-lg p-4">
              <p className="text-sm text-amber-800 font-medium mb-1">
                ※ 홈페이지 뿐 아니라 전화로도 접수 가능합니다. (031-866-5670)
              </p>
              <p className="text-sm text-amber-800">
                ※ 홈페이지 신청 후에도 담당자와의 확인통화를 거쳐야만 접수가 확정되니 유의하세요.
              </p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default GroupApplication;
